export default "__VITE_ASSET__BQqVT9Z3__"